<template>
  <div
    class="buildup sticky-ui-wrapper"
    @mousemove="moveLayer"
    @mouseleave="stopLayerMove">
    <div class="buildup-ui sticky-ui">
      <toggle-switch v-model="showBlockFrames">
        Pokaż ramki elementów
      </toggle-switch>

      <small
        v-if="editView === 'texts'"
        class="buildup-text-layers-notice">
        Aby przenosić warstwy tekstowe kliknij dwukrotnie na tekście, który chcesz przenieść.
      </small>
    </div>
    <div
      ref="buildup"
      class="buildup-area mb-3"
      :data-height="calculateHeight">
      <div class="buildup-area-lines-y">
        <div
          v-for="(line, index) of calculateHeight"
          :key="'line-y-' + index"
          class="buildup-area-line-y"></div>
      </div>

      <div class="buildup-area-lines-x">
        <div
          v-for="(line, index) of new Array(15)"
          :key="'line-x-' + index"
          class="buildup-area-line-x"></div>
      </div>

      <div :class="{ 'buildup-area-content': true, 'is-showing-frames': showBlockFrames }">
        <template v-for="(block, index) of blocks">
          <div
            v-if="block.type === 'ingredient'"
            :data-id="block.id"
            :key="'block-' + index"
            :data-quantity="block.quantity"
            :class="{
              'buildup-area-content-ingredient': block.type === 'ingredient',
              'is-selected': editView === 'blocks' && block.id === selectedBlock,
              'is-big-ingredient': !!isBigBlock[block.id]
            }"
            :style="'left: 400px; top: ' + calculateBlockPositionY(index) + 'px;'">
            <img
              v-if="block.ingredient_id && ingredientsData && ingredientsData.length > 0"
              v-for="(img, index) of new Array(parseInt(block.quantity, 10))"
              :key="'ingredient-image-' + index"
              :src="getIngredientImage(block.ingredient_id)"
              alt="" />
            <div
              v-if="block.label !== ''"
              :data-position="block.label_position"
              class="buildup-area-content-ingredient-label"
              :style="{
                fontSize: block.font_size + 'px',
                lineHeight: `${Math.max(block.font_size, 50)}px`,
                minHeight: `${Math.max(block.font_size, 50)}px`
              }">
              {{ block.label }}
            </div>
          </div>

          <div
            v-if="block.type === 'spacer'"
            :data-id="block.id"
            :key="'block-' + index"
            :data-quantity="block.quantity"
            :class="{
              'buildup-area-content-spacer': true,
              'is-spacer-small' : block.space === 'small',
              'is-spacer-medium': block.space === 'medium',
              'is-selected': editView === 'blocks' && block.id === selectedBlock
            }"
            :style="'left: 400px; top: ' + calculateBlockPositionY(index) + 'px;'">
          </div>

          <div
            v-if="block.type === 'columns'"
            :data-id="block.id"
            :key="'block-' + index"
            :data-columns="block.columns"
            :class="{
              'buildup-area-content-columns': true,
              'is-selected': editView === 'blocks' && block.id === selectedBlock
            }"
            :style="'left: 400px; top: ' + calculateBlockPositionY(index) + 'px;'">
            <div
              v-for="(column, subindex) of new Array(parseInt(block.columns, 10))"
              :key="'block-' + index + '-column-' + subindex"
              :class="{ 'buildup-area-content-columns-column': true, 'is-empty': block.columnsContent[subindex] === null }"
              @click="addColumnIngredient(index, subindex)"
              :data-quantity="getImages(index, subindex).length">
              <img
                v-for="(img, imageIndex) of getImages(index, subindex)"
                :key="'block-' + index + '-column-' + subindex + '-ingredient-image-' + imageIndex"
                :src="getIngredientImage(block.columnsContent[subindex].ingredient_id)"
                alt="" />
              <div
                v-if="block.columnsContent[subindex] && block.columnsContent[subindex].label !== ''"
                :data-position="block.columnsContent[subindex].label_position"
                class="buildup-area-content-ingredient-label"
                :style="{
                  fontSize: block.columnsContent[subindex].font_size + 'px',
                  lineHeight: `${Math.max(block.columnsContent[subindex].font_size, 50)}px`,
                  minHeight: `${Math.max(block.columnsContent[subindex].font_size, 50)}px`
                }">
                {{ block.columnsContent[subindex].label }}
              </div>

              <a
                v-if="block.columnsContent[subindex] !== null"
                href="#delete"
                class="item-remove text-white"
                @click.stop.prevent="removeColumnIngredient(index, subindex)">
                <i class="material-icons">delete</i>
              </a>

              <a
                v-if="block.columnsContent[subindex] !== null"
                href="#delete"
                class="item-edit text-white"
                @click.stop.prevent="editColumnIngredient(index, subindex)">
                <i class="material-icons">create</i>
              </a>
            </div>
          </div>
        </template>

        <div
          v-for="(layer, index) of layers"
          :key="'layer-' + index"
          :data-id="layer.id"
          :class="{
            'buildup-area-content-text-layer': true,
            'is-inactive': !!movedItem && movedItem.itemID !== layer.id,
            'is-not-moveable': editView === 'blocks',
            'is-selected': editView === 'texts' && layer.id === selectedBlock
          }"
          :style="'left: ' + layer.position.x + 'px; top: ' + layer.position.y + 'px;'"
          :data-text-align="layer.textAlign"
          @dblclick="selectLayer(layer.id)"
          @mousedown="startLayerMove(layer.id)"
          @mouseup="stopLayerMove"
          @mouseleave="stopLayerMove">
          <span>{{ layer.text }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ToggleSwitch from './../common/ToggleSwitch.vue';

export default {
  name: 'buildup',
  props: [
    'blocks',
    'editView',
    'ingredientsData',
    'layers',
    'selectedBlock',
    'units'
  ],
  components: {
    'toggle-switch': ToggleSwitch
  },
  computed: {
    calculateHeight () {
      let smallSpaces = this.blocks.filter(block => block.type === 'spacer' && block.space === 'small').length * 50;
      let mediumSpaces = this.blocks.filter(block => block.type === 'spacer' && block.space === 'medium').length * 100;
      let bigSpaces = this.blocks.filter(block => block.type === 'spacer' && block.space === 'big').length * 200;
      let normalIngredientsAndColumnsBlocks = this.blocks.filter(block => (block.type === 'ingredient' && !this.isBigBlock[block.id]) || block.type === 'columns').length * 200;
      let bigIngredientsBlocks = this.blocks.filter(block => block.type === 'ingredient' && !!this.isBigBlock[block.id]).length * 400;

      return (smallSpaces + mediumSpaces + bigSpaces + normalIngredientsAndColumnsBlocks + bigIngredientsBlocks) / 50;
    },
    isBigBlock () {
      let blocks = {};

      for (let i = 0; i < this.blocks.length; i++) {
        let id = this.blocks[i].id;
        let value = !!this.checkIfIsBigIngredient(this.blocks[i].ingredient_id);
        blocks[id] = value;
      }

      return blocks;
    }
  },
  data () {
    return {
      movedItem: false,
      showBlockFrames: false
    };
  },
  methods: {
    calculateBlockPositionY (index) {
      let position = 100;

      if (this.blocks[index] && this.blocks[index].type === 'ingredient' && !!this.isBigBlock[this.blocks[index].id]) {
        position += 100;
      }

      if (this.blocks[index].type === 'spacer' && this.blocks[index].space === 'small') {
        position = 25;
      } else if (this.blocks[index].type === 'spacer' && this.blocks[index].space === 'medium') {
        position = 50;
      }

      for (let i = 0; i < index; i++) {
        if (this.blocks[i].type === 'spacer') {
          if (this.blocks[i].space === 'small') {
            position += 50;
          } else if (this.blocks[i].space === 'medium') {
            position += 100;
          } else if (this.blocks[i].space === 'big') {
            position += 200;
          }
        } else if (this.blocks[i].type === 'ingredient' && !!this.isBigBlock[this.blocks[i].id]) {
          position += 400;
        } else {
          position += 200;
        }
      }

      return position;
    },
    getIngredientImage (ingredientID) {
      let foundedIngredient = this.ingredientsData.filter(ingredient => ingredient.id === ingredientID);

      if (foundedIngredient && foundedIngredient[0] && foundedIngredient[0].image_url) {
        return foundedIngredient[0].image_url;
      }

      return '';
    },
    checkIfIsBigIngredient (ingredientID) {
      let foundedIngredient = this.ingredientsData.filter(ingredient => ingredient.id === ingredientID);

      if (foundedIngredient && foundedIngredient[0]) {
        return !!foundedIngredient[0].is_big_ingredient;
      }

      return false;
    },
    moveLayer (e) {
      if (!this.movedItem) {
        return;
      }

      let x = e.pageX - this.$refs['buildup'].getBoundingClientRect().left;
      let y = e.pageY - ((this.$refs['buildup'].getBoundingClientRect().top + window.pageYOffset));
      this.$bus.emit('buildup-layer-move', this.movedItem, x, y);
    },
    startLayerMove (itemID) {
      if (this.selectedBlock !== itemID) {
        this.movedItem = false;
        return;
      }

      this.movedItem = {
        itemID
      };
    },
    stopLayerMove () {
      this.movedItem = false;
    },
    selectLayer (itemID) {
      this.$bus.emit('buildup-layer-select', itemID);
    },
    removeBlock (index) {
      this.data.blocks.splice(index, 1);
    },
    ingredientUnits (ingredientID) {
      let foundedIngredient = this.ingredientsData.filter(ingredient => ingredient.id === ingredientID)[0];

      if (foundedIngredient && foundedIngredient.units) {
        return foundedIngredient.units.map(unit => unit.unit)
      }

      return [];
    },
    ingredientIsCountable (index, subindex) {
      let unitID = this.blocks[index].columnsContent[subindex].unit_id;

      if (unitID && this.units.length) {
        return !!this.units.filter(unit => unit.id === unitID)[0].is_countable;
      }

      return false;
    },
    addColumnIngredient (index, subindex) {
      if (this.blocks[index].columnsContent[subindex] === null) {
        this.$bus.emit('buildup-block-column-add-ingredient', index, subindex);
      }
    },
    editColumnIngredient (index, subindex) {
      this.$bus.emit('buildup-block-column-edit-ingredient', index, subindex);
    },
    removeColumnIngredient(index, subindex) {
      this.$bus.emit('buildup-block-column-remove-ingredient', index, subindex);
    },
    resetIngredientParams (index, subindex) {
      this.$bus.emit('buildup-block-column-reset-ingredient', index, subindex);
    },
    getImages (index, subindex) {
      if (!this.blocks[index].columnsContent[subindex]) {
        return [];
      }

      return new Array(parseInt(this.blocks[index].columnsContent[subindex].quantity, 10))
    }
  }
}
</script>

<style lang="scss" scoped>
.buildup {
  margin: 0 auto 50px auto;
  user-select: none;

  &-ui {
    align-items: center;
    display: flex;
    height: 50px;
    justify-content: center;
    margin-bottom: 30px;
    position: absolute;
    top: 10px;
    width: 100%;

    .buildup-text-layers-notice {
      bottom: 0px;
      left: 50%;
      position: absolute;
      text-align: center;
      transform: translateX(-50%);
      width: 100%;
    }
  }

  &-area {
    background: rgba(255, 255, 255, .5);
    border: 1px dashed #ccc;
    margin: 0 auto;
    position: relative;
    width: 802px;

    &-lines-x,
    &-lines-y,
    &-content {
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }

    &-line-y {
      border-top: 1px dashed #ccc;
      height: 1px;
      left: 0;
      position: absolute;
      width: 100%;

      &:last-of-type {
        display: none;
      }
    }

    &-line-x {
      border-left: 1px dashed #ccc;
      height: 100%;
      left: 6.25%;
      position: absolute;
      width: 1px;

      @for $i from 2 through 15 {
        &:nth-child(#{$i}) {
          left: calc(#{$i} * 6.25%);
        }
      }
    }

    @for $i from 0 through 200 {
      &[data-height="#{$i}"] {
        height: calc((#{$i} * 50px) + 2px);
      }

      &-line-y:nth-child(#{$i}) {
        top: calc(#{$i} * 50px);
      }
    }

    &[data-height="0"] {
      display: none;
    }

    &-content {
      overflow: hidden;
      z-index: 1;

      &-spacer {
        border: 2px dashed transparent;
        border-radius: 10px;
        height: 200px;
        position: absolute;
        transform: translateX(-50%) translateY(-50%);
        width: 800px;

        &.is-spacer-small {
          height: 50px;
        }

        &.is-spacer-medium {
          height: 100px;
        }
      }

      &-columns {
        border: 2px dashed transparent;
        border-radius: 10px;
        display: grid;
        height: 200px;
        position: absolute;
        transform: translateX(-50%) translateY(-50%);
        width: 800px;

        &[data-columns="2"] {
          grid-template-columns: 1fr 1fr;
        }

        &[data-columns="3"] {
          grid-template-columns: 1fr 1fr 1fr;
        }

        &[data-columns="4"] {
          grid-template-columns: 1fr 1fr 1fr 1fr;
        }

        &-column {
          border-right: 2px dashed transparent;
          height: 200px;
          position: relative;

          &:last-child {
            border-right: none;
          }

          &.is-empty {
            &:before {
              background: var(--secondary);
              border-radius: 50%;
              color: var(--white);
              content: "+";
              display: flex;
              font-size: 48px;
              font-weight: bold;
              height: 48px;
              justify-content: center;
              left: 50%;
              line-height: 41px;
              position: absolute;
              top: 50%;
              transform: translateX(-50%) translateY(-50%);
              width: 48px;
            }
          }

          .item-edit,
          .item-remove {
            align-items: center;
            background: var(--danger);
            border-radius: 50%;
            display: none;
            height: 30px;
            justify-content: center;
            position: absolute;
            right: 10px;
            top: 10px;
            width: 30px;

            i {
              position: relative;
              top: 0px;
            }
          }

          .item-edit {
            background: var(--primary);
            left: 10px;
            right: auto;
          }

          &:hover {
            .item-edit,
            .item-remove {
              display: flex;
              text-decoration: none;
            }
          }
        }
      }

      &-text-layer {
        border: 2px dashed transparent;
        border-radius: 10px;
        font-size: 24px;
        font-weight: bold;
        line-height: 46px;
        min-height: 50px;
        padding: 0 20px;
        position: absolute;
        transform: translateX(-50%) translateY(-50%);
        width: 800px;
        z-index: 10;

        & > span {
          user-select: none;
        }

        &[data-text-align="left"] {
          text-align: left;
        }

        &[data-text-align="center"] {
          text-align: center;
        }

        &[data-text-align="right"] {
          text-align: right;
        }

        &.is-not-moveable {
          pointer-events: none;
        }
      }

      &-ingredient {
        border: 2px dashed transparent;
        border-radius: 10px;
        height: 200px;
        position: absolute;
        transform: translateX(-50%) translateY(-50%);
        width: 800px;

        &-label {
          font-size: 24px;
          font-weight: bold;
          height: auto;
          left: 50%;
          line-height: 50px;
          min-height: 50px;
          padding: 0 20px;
          position: absolute;
          text-align: center;
          transform: translateX(-50%);
          width: 100%;

          &[data-position="top"] {
            top: 0;
          }

          &[data-position="bottom"] {
            bottom: 0;
          }
        }

        img {
          height: 200px;
          left: 50%;
          object-fit: contain;
          pointer-events: none;
          position: absolute;
          top: 50%;
          transform: translateX(-50%) translateY(-50%);
          width: 800px;
        }

        &.is-big-ingredient {
          height: 400px;

          img {
            height: 400px;
          }
        }

        &[data-quantity="2"] {
          img {
            left: calc(50% - 50px); top: 50%;
            &:nth-child(2) { left: calc(50% + 50px); top: 50%; }
          }
        }

        &[data-quantity="3"] {
          img {
            left: 50%; top: calc(50% - 12.5px);
            &:nth-child(2) { left: calc(50% - 50px); top: calc(50% + 12.5px); }
            &:nth-child(3) { left: calc(50% + 50px); top: calc(50% + 12.5px); }
          }
        }

        &[data-quantity="4"] {
          img {
            left: 50%; top: calc(50% - 15px);
            &:nth-child(2) { left: calc(50% - 50px); top: 50%; }
            &:nth-child(3) { left: calc(50% + 50px); top: 50%; }
            &:nth-child(4) { left: 50%; top: calc(50% + 15px); }
          }
        }

        &[data-quantity="5"] {
          img {
            left: calc(50% - 25px); top: calc(50% - 15px);
            &:nth-child(2) { left: calc(50% + 25px); top: calc(50% - 15px); }
            &:nth-child(3) { left: calc(50% - 50px); top: calc(50% + 15px); }
            &:nth-child(4) { left: 50%; top: calc(50% + 15px); }
            &:nth-child(5) { left: calc(50% + 50px); top: calc(50% + 15px); }
          }
        }

        &[data-quantity="6"] {
          img {
            left: calc(50% - 50px); top: calc(50% - 15px);
            &:nth-child(2) { left: 50%; top: calc(50% - 15px); }
            &:nth-child(3) { left: calc(50% + 50px); top: calc(50% - 15px); }
            &:nth-child(4) { left: calc(50% - 50px); top: calc(50% + 15px); }
            &:nth-child(5) { left: 50%; top: calc(50% + 15px); }
            &:nth-child(6) { left: calc(50% + 50px); top: calc(50% + 15px); }
          }
        }

        &[data-quantity="7"] {
          img {
            left: calc(50% - 50px); top: calc(50% - 15px);
            &:nth-child(2) { left: 50%; top: calc(50% - 15px); }
            &:nth-child(3) { left: calc(50% + 50px); top: calc(50% - 15px); }
            &:nth-child(4) { left: calc(50% - 85px); top: calc(50% + 15px); }
            &:nth-child(5) { left: calc(50% - 25px); top: calc(50% + 15px); }
            &:nth-child(6) { left: calc(50% + 25px); top: calc(50% + 15px); }
            &:nth-child(7) { left: calc(50% + 85px); top: calc(50% + 15px); }
          }
        }

        &[data-quantity="8"] {
          img {
            left: calc(50% - 85px); top: calc(50% - 15px);
            &:nth-child(2) { left: calc(50% - 25px); top: calc(50% - 15px); }
            &:nth-child(3) { left: calc(50% + 25px); top: calc(50% - 15px); }
            &:nth-child(4) { left: calc(50% + 85px); top: calc(50% - 15px); }
            &:nth-child(5) { left: calc(50% - 85px); top: calc(50% + 15px); }
            &:nth-child(6) { left: calc(50% - 25px); top: calc(50% + 15px); }
            &:nth-child(7) { left: calc(50% + 25px); top: calc(50% + 15px); }
            &:nth-child(8) { left: calc(50% + 85px); top: calc(50% + 15px); }
          }
        }
      }

      .buildup-area-content-columns-column {
        img {
          height: 100px;
          left: 50%;
          pointer-events: none;
          position: absolute;
          top: 50%;
          transform: translateX(-50%) translateY(-50%);
        }

        &[data-quantity="2"] {
          img {
            left: calc(50% - 50px); top: 50%;
            &:nth-child(2) { left: calc(50% + 50px); top: 50%; }
          }
        }

        &[data-quantity="3"] {
          img {
            left: 50%; top: calc(50% - 12.5px);
            &:nth-child(2) { left: calc(50% - 50px); top: calc(50% + 12.5px); }
            &:nth-child(3) { left: calc(50% + 50px); top: calc(50% + 12.5px); }
          }
        }

        &[data-quantity="4"] {
          img {
            left: 50%; top: calc(50% - 15px);
            &:nth-child(2) { left: calc(50% - 50px); top: 50%; }
            &:nth-child(3) { left: calc(50% + 50px); top: 50%; }
            &:nth-child(4) { left: 50%; top: calc(50% + 15px); }
          }
        }

        &[data-quantity="5"] {
          img {
            left: calc(50% - 25px); top: calc(50% - 15px);
            &:nth-child(2) { left: calc(50% + 25px); top: calc(50% - 15px); }
            &:nth-child(3) { left: calc(50% - 50px); top: calc(50% + 15px); }
            &:nth-child(4) { left: 50%; top: calc(50% + 15px); }
            &:nth-child(5) { left: calc(50% + 50px); top: calc(50% + 15px); }
          }
        }

        &[data-quantity="6"] {
          img {
            left: calc(50% - 50px); top: calc(50% - 15px);
            &:nth-child(2) { left: 50%; top: calc(50% - 15px); }
            &:nth-child(3) { left: calc(50% + 50px); top: calc(50% - 15px); }
            &:nth-child(4) { left: calc(50% - 50px); top: calc(50% + 15px); }
            &:nth-child(5) { left: 50%; top: calc(50% + 15px); }
            &:nth-child(6) { left: calc(50% + 50px); top: calc(50% + 15px); }
          }
        }

        &[data-quantity="7"] {
          img {
            left: calc(50% - 50px); top: calc(50% - 15px);
            &:nth-child(2) { left: 50%; top: calc(50% - 15px); }
            &:nth-child(3) { left: calc(50% + 50px); top: calc(50% - 15px); }
            &:nth-child(4) { left: calc(50% - 85px); top: calc(50% + 15px); }
            &:nth-child(5) { left: calc(50% - 25px); top: calc(50% + 15px); }
            &:nth-child(6) { left: calc(50% + 25px); top: calc(50% + 15px); }
            &:nth-child(7) { left: calc(50% + 85px); top: calc(50% + 15px); }
          }
        }

        &[data-quantity="8"] {
          img {
            left: calc(50% - 85px); top: calc(50% - 15px);
            &:nth-child(2) { left: calc(50% - 25px); top: calc(50% - 15px); }
            &:nth-child(3) { left: calc(50% + 25px); top: calc(50% - 15px); }
            &:nth-child(4) { left: calc(50% + 85px); top: calc(50% - 15px); }
            &:nth-child(5) { left: calc(50% - 85px); top: calc(50% + 15px); }
            &:nth-child(6) { left: calc(50% - 25px); top: calc(50% + 15px); }
            &:nth-child(7) { left: calc(50% + 25px); top: calc(50% + 15px); }
            &:nth-child(8) { left: calc(50% + 85px); top: calc(50% + 15px); }
          }
        }
      }

      .buildup-area-content-ingredient,
      .buildup-area-content-spacer,
      .buildup-area-content-columns,
      .buildup-area-content-text-layer {
        &.is-selected {
          background: rgba(255, 244, 222, .33);
          border-color: #eedda9;

          .buildup-area-content-columns-column {
            border-color: #eedda9;

            &.is-empty {
              &:before {
                background: #eedda9;
              }
            }
          }
        }
      }

      .buildup-area-content-text-layer {
        &.is-selected {
          cursor: move;
          z-index: 999;
        }
      }

      &.is-showing-frames {
        .buildup-area-content-ingredient,
        .buildup-area-content-spacer,
        .buildup-area-content-columns,
        .buildup-area-content-text-layer {
          border-color: #aaa;

          .buildup-area-content-columns-column {
            border-color: #aaa;
          }

          &.is-selected {
            border-color: #eedda9;

            .buildup-area-content-columns-column {
              border-color: #eedda9;

              &.is-empty {
                &:before {
                  background: #eedda9;
                }
              }
            }
          }
        }
      }
    }
  }
}

.sticky-ui-wrapper {
  position: relative;

  .sticky-ui {
    background: #f5f6f8;
    box-shadow: 0 0 30px #f5f6f8, 0 0 25px #f5f6f8, 0 0 20px #f5f6f8, 0 0 15px #f5f6f8, 0 0 10px #f5f6f8;
    left: 0;
    margin-left: -10px;
    margin-right: -10px;
    position: sticky;
    top: 0;
    width: calc(100% + 20px);
    z-index: 1000;
  }
}
</style>
